import { CanActivateFn } from '@angular/router';
import { RouterPath } from '../../shared/models';
import { inject } from '@angular/core';
import { LocaleService } from '../services/locale.service';
import { AppStateService } from '../services/app-state.service';

/**
 * Guard that requires the user to be authenticated.
 * Use permissionGuard in addition on routes that need a specific permission (via data.permission).
 */
export const authGuard: CanActivateFn = (_route, _state) => {
    const localeService = inject(LocaleService);
    const appStateService = inject(AppStateService);

    if (localStorage.getItem('token')) {
        return true;
    }

    // 1. In-app click: stay on current page and show login modal (navigation is cancelled).
    // 2. Back/Forward (popstate): redirect to home so we never show empty outlet, then show login modal.
    // 3. Direct address link (typed/pasted URL): redirect to forbidden page.
    const isInAppClick =
        appStateService.lastNavigationTrigger === 'imperative' &&
        appStateService.hasNavigatedInApp();
    const isBackOrForward = appStateService.lastNavigationTrigger === 'popstate';

    if (isInAppClick) {
        appStateService.nextLoginValue(true);
        return false;
    }

    if (isBackOrForward) {
        localeService.navigate(RouterPath.HOME);
        appStateService.nextLoginValue(true);
        return false;
    }

    localeService.navigate(RouterPath.FORBIDDEN);
    return false;
};
